import type { EventEditStep, PlanTab, WizardStep, WizardStepId } from './eventWizard.types';

// The review step is not listed here: it is always the one past the last visible step.
export const STEPS: readonly WizardStep[] = [
  { id: 'details', label: 'Details', hint: 'Name, date & description', required: true },
  { id: 'location', label: 'Location', hint: 'Where it happens', required: false },
  { id: 'audience', label: 'Audience', hint: "Who it's for", required: false },
  { id: 'plan', label: 'Plan Event', hint: 'Itinerary & tasks', required: false },
];

/**
 * Each part of an existing event the wizard can be opened on: the step it lands
 * on, the tab within it, and what the modal calls itself there.
 */
export const EDIT_STEPS: Record<
  EventEditStep,
  { step: WizardStepId; title: string; planTab?: PlanTab }
> = {
  details: { step: 'details', title: 'Edit Details' },
  location: { step: 'location', title: 'Edit Location' },
  audience: { step: 'audience', title: 'Edit Audience' },
  itinerary: { step: 'plan', planTab: 'itinerary', title: 'Edit Itinerary' },
};

export const LOCATION_OPTIONS = [
  { value: 'Miami, FL, USA', label: 'Miami, FL, USA' },
  { value: 'Fort Lauderdale, FL, USA', label: 'Fort Lauderdale, FL, USA' },
  { value: 'Palm Beach, FL, USA', label: 'Palm Beach, FL, USA' },
  { value: 'Newport, RI, USA', label: 'Newport, RI, USA' },
  { value: 'Annapolis, MD, USA', label: 'Annapolis, MD, USA' },
  { value: 'San Diego, CA, USA', label: 'San Diego, CA, USA' },
];

export const AUDIENCE_OPTIONS = [
  { id: 'guests', emoji: '✉️', label: 'Invite Guests', desc: 'Build a guest list for this event.' },
  {
    id: 'team',
    emoji: '⚓',
    label: 'Owners & Crew',
    desc: 'The owners and every crew member join automatically.',
  },
];

export const MAX_EVENT_DAYS = 14;

export const EVENT_TYPES = [
  { id: 'general', label: 'General', emoji: '📅', desc: 'All-purpose event for any occasion' },
  { id: 'guest', label: 'Guest Event', emoji: '🥂', desc: 'Curated experience for special guests' },
  {
    id: 'food',
    label: 'Food & Dining',
    emoji: '🍽️',
    desc: 'Culinary experiences and gourmet gatherings',
  },
  { id: 'voyage', label: 'Voyage', emoji: '⛵', desc: 'Private on-water journey or sea adventure' },
];
